import {
  BannerFragment
  // CartFragment
  //ThresholdedRule
} from '@/fo/api/magento';
import { ContentWithFootnoteSup } from '@/fo/ui/mod/footnote/base';

import { UiCartInformerAdditionalProps } from '../lib/UiCartInformerAdditional';

export const mapBannersFromData = (
  banner: BannerFragment
): UiCartInformerAdditionalProps => {
  return {
    title: (
      <ContentWithFootnoteSup
        id={banner.id}
        content={banner.banner_data?.small_text || ''}
      />
    ),
    href: banner.banner_data?.first_link || '',
    image: banner.banner_data?.desktop_image || '',
    action: banner.banner_data?.first_link_label || '',
    target: banner.banner_data?.first_link_new_tab || false
  };
};

export const mapSamplesBannerFromData = (
  banner: BannerFragment
  //thresholdedRules?: ThresholdedRule[],
  //cart?: CartFragment
): UiCartInformerAdditionalProps => {
  //const nextBonus = thresholdedRules?.find((item) => !item.is_reached);
  //const totalAmount = cart?.prices?.grand_total?.value ?? 0;
  const price = /*nextBonus ? nextBonus.minimal_total - totalAmount : 0;*/ 0;

  return {
    title: (
      <ContentWithFootnoteSup
        id={banner.id}
        content={
          banner.banner_data?.small_text?.replace(
            '{price}',
            price.toString()
          ) || ''
        }
      />
    ),
    href: banner.banner_data?.first_link || '',
    image: banner.banner_data?.desktop_image || '',
    action: banner.banner_data?.first_link_label || '',
    target: banner.banner_data?.first_link_new_tab || false,
    variant: 'rounded'
  };
};
